import { jsx as H } from "react/jsx-runtime";
import { useRef as q, useEffect as m, useCallback as v, useMemo as J, useLayoutEffect as z } from "react";
import B from "../../../../make-cancellable-promise/dist/esm/index.es.js";
import { clsx as F } from "../../../../clsx/dist/clsx.es.js";
import M from "../../../../tiny-invariant/dist/esm/tiny-invariant.es.js";
import x from "../../../../warning/warning.es.js";
import { TextLayer as K } from "../../../node_modules/pdfjs-dist/build/pdf.es.js";
import Q from "../shared/hooks/usePageContext.es.js";
import W from "../shared/hooks/useResolver.es.js";
import { cancelRunningTask as P } from "../shared/utils.es.js";
function X(s) {
  return "str" in s;
}
function ce() {
  const s = Q();
  M(s, "Unable to find Page context.");
  const { customTextRenderer: u, onGetTextError: y, onGetTextSuccess: g, onRenderTextLayerError: f, onRenderTextLayerSuccess: l, page: t, pageIndex: T, pageNumber: C, rotate: E, scale: L } = s;
  M(t, "Attempted to load page text content, but no page was specified.");
  const [j, o] = W(), { value: n, error: p } = j, c = q(null);
  x(Number.parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-text-layer"), 10) === 1, "TextLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-text-layer");
  function N() {
    n && g && g(n);
  }
  function O() {
    p && (x(!1, p.toString()), y && y(p));
  }
  m(function() {
    o({ type: "RESET" });
  }, [t, o]), m(function() {
    if (!t)
      return;
    const r = B(t.getTextContent()), d = r;
    return r.promise.then((a) => {
      o({ type: "RESOLVE", value: a });
    }).catch((a) => {
      o({ type: "REJECT", error: a });
    }), () => P(d);
  }, [t, o]), m(() => {
    if (n !== void 0) {
      if (n === !1) {
        O();
        return;
      }
      N();
    }
  }, [n]);
  const b = v(() => {
    l && l();
  }, [l]), R = v((e) => {
    x(!1, e.toString()), f && f(e);
  }, [f]);
  function D() {
    const e = c.current;
    e && e.classList.add("selecting");
  }
  function I() {
    const e = c.current;
    e && e.classList.remove("selecting");
  }
  const S = J(() => t.getViewport({ scale: L, rotation: E }), [t, E, L]);
  return z(function() {
    if (!t || !n)
      return;
    const { current: r } = c;
    if (!r)
      return;
    r.innerHTML = "";
    const d = t.streamTextContent({ includeMarkedContent: !0 }), a = {
      container: r,
      textContentSource: d,
      viewport: S
    }, h = new K(a), U = h;
    return h.render().then(() => {
      const w = document.createElement("div");
      w.className = "endOfContent", r.append(w);
      const V = r.querySelectorAll('[role="presentation"]');
      if (u) {
        let _ = 0;
        n.items.forEach((i, A) => {
          if (!X(i))
            return;
          const k = V[_];
          if (!k)
            return;
          const G = u(Object.assign({
            pageIndex: T,
            pageNumber: C,
            itemIndex: A
          }, i));
          k.innerHTML = G, _ += i.str && i.hasEOL ? 2 : 1;
        });
      }
      b();
    }).catch(R), () => P(U);
  }, [
    u,
    R,
    b,
    t,
    T,
    C,
    n,
    S
  ]), H("div", { className: F("react-pdf__Page__textContent", "textLayer"), onMouseUp: I, onMouseDown: D, ref: c });
}
export {
  ce as default
};
//# sourceMappingURL=TextLayer.es.js.map
